import { Component } from '@angular/core';
import {
    EventStatusFilterEnum,
    EventStatusFilterEnumLabelMap,
} from '../../../../models/events/event-status-filter.enum';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { BaseFiltersCheckbox } from '../../../shared/base-filters-checkbox/base-filters-checkbox.directive';

@Component({
    selector: 'app-joined-events-canceled-checkbox',
    templateUrl: './joined-events-canceled-checkbox.component.html',
    providers: [{ provide: BaseFiltersCheckbox, useExisting: JoinedEventsCanceledCheckboxComponent }],
})
export class JoinedEventsCanceledCheckboxComponent extends BaseFiltersCheckbox {
    protected override createFilterItem(): FiltersItem {
        const value = EventStatusFilterEnum.IsCanceled;
        return new FiltersItem(
            `Joined.${EventStatusFilterEnum[value]}`,
            `${this.wtranslate.transform(
                EventStatusFilterEnumLabelMap[value],
                'eventStatuses',
            )} ${this.translate.instant('events.shared.byOrganizer')}`,
        );
    }
}
